import styled from '@emotion/styled'

import { Space } from '../../atoms'

export const StyledSuccessText = styled(Space)`
  div {
    color: var(--Success);
  }
`
